module.exports = __webpack_public_path__ + "static/media/facebook.77d199c5.png";